import { excelFormulaEscaped } from "../../../../core/helpers/string-util.js";
import ReportVisitor from "../../../../models/reports/reports/ReportVisitor.js";

/**
 * Simple CVS exporter.
 */
export default class CsvExportingVisitor extends ReportVisitor {
	visitReport(report) {
		this._report = report;
		const titles = this._report
			.getColumns()
			.map(
				(column) =>
					`"${this._excelFormulaEscaped(
						column.getFullTitleString(),
					)}"`,
			);
		const data = this.visitAll(this._report.getRows());

		return `${this._columnReducer([" ", ...titles])}\n${this._rowReducer(
			data,
		)}`;
	}

	visitAbstractRow(row) {
		this._row = row;
		return this._columnReducer([
			`"${this._excelFormulaEscaped(row.getFullTitleString())}"`,
			...this.visitAll(this._report.getColumns()),
		]);
	}

	visitSpacerRow() {}

	visitGroupRow(group) {
		return this._rowReducer(this.visitAll(group.getAllLeafRows()));
	}

	visitAbstractColumn(column) {
		return this._excelFormulaEscaped(
			this._report.getData({ column, row: this._row }),
		);
	}

	_columnReducer(data) {
		return data.reduce((acc, string) => {
			if (acc) {
				return `${acc},${string}`;
			}
			return string;
		}, "");
	}

	_rowReducer(data) {
		return data.reduce((acc, string) => {
			if (acc) {
				return `${acc}\n${string}`;
			}
			return string;
		}, "");
	}

	_excelFormulaEscaped(string) {
		return excelFormulaEscaped(string);
	}
}
